let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9i6IA")).then(() => parcelRequire('L37mU'));